// src/app/modules/Visitors/pages/components/FlagVisitorModal.jsx
import React, { useState, useRef, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import * as actions from '../../../Dashbord/_redux/dashboard/Actions';
import { X, Flag } from 'lucide-react';
import './FlagVisitorModal.scss';

export function FlagVisitorModal({ show, onHide, profileId, onSuccess }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const isMountedRef = useRef(true);
const [reason, setReason] = useState('');


  useEffect(() => {
    isMountedRef.current = true;
    
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  // Reset form when modal closes
  useEffect(() => {
    if (!show) {
      setReason('');
      setLoading(false);
    }
  }, [show]);

  async function handleSubmit(e) {
    e.preventDefault();
    
    if (!isMountedRef.current) return;
    
    setLoading(true);

    try {
      await dispatch(actions.addData('flag_visitor', { reason, profile_id: profileId }));
      
      if (isMountedRef.current) {
        setReason('');
        onHide();
        if (onSuccess) onSuccess();
      }
    } catch (error) {
      console.error('Error flagging visitor:', error);
    } finally {
      if (isMountedRef.current) {
        setLoading(false);
      }
    }
  }

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered 
      size="md"
      className="flag-visitor-modal"
    >
      <div className="flag-modal-content">
        <div className="modal-header-custom">
          <h3>Flag Visitor</h3>
          <button className="btn-close-custom" onClick={onHide} disabled={loading}>
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body-custom">
            <div className="flag-icon-wrapper">
              <div className="flag-icon">
                <Flag size={32} />
              </div>
            </div>

            <h4 className="text-center mb-3">Flag Visitor for Review</h4>
            <p className="text-muted text-center mb-4">
              This will mark the visitor for manual review and additional screening.
            </p>

            <div className="form-group">
              <label>Reason for Flagging *</label>
              <textarea
                className="form-control"
                rows="4"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Enter the reason for flagging this visitor..."
                required
              />
            </div>
          </div>

          <div className="modal-footer-custom">
            <button 
              type="button" 
              className="btn-cancel" 
              onClick={onHide}
              disabled={loading}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="btn-flag" 
              disabled={loading || !reason}
            >
              {loading ? (
                <>
                  <span className="spinner"></span>
                  Flagging...
                </>
              ) : (
                <>
                  <Flag size={16} />
                  Flag Visitor
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
}